<div class="modal-border">
  <ion-header>
    <ion-toolbar text-center>
      <ion-title>Change Log</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismissModal()" size="large">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <h4 style="font-weight: bold">Version 2.1.0</h4>
    <div class="changelog-content" [innerHTML]="fileContent"></div>
  </ion-content>
</div>
